/* eslint-disable no-shadow,import/no-import-module-exports */
import { keyify } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { createSelector } from 'reselect';

import { stateParamsSelectorFactory, previousStateParams } from '@Selectors/StateParamsSelectors';
import { commercialSuppliersFilterId } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { listOfFiltersReducerKey } from './ListOfFiltersConstants';

export function listOfFiltersState(state) {
  return state.get(listOfFiltersReducerKey);
}

// eslint-disable-next-line no-use-before-define
export const filters = createSelector([filtersItems, filtersIds], (filtersItems, filtersIds) => {
  if (!filtersItems) {
    return null;
  }

  return filtersIds.map((id) => {
    return filtersItems.get(id);
  });
});

export function filtersItems(state) {
  return listOfFiltersState(state).getIn([keyifyParamsForFiltersRequest(state), 'items']);
}

export function filtersIds(state) {
  return listOfFiltersState(state).getIn([keyifyParamsForFiltersRequest(state), 'ids']);
}

export const paramsForFiltersRequest = stateParamsSelectorFactory(['context', 'databaseId', 'resultName', 'hitSetKey']);

export const previousParamsForFiltersRequest = stateParamsSelectorFactory(
  ['context', 'databaseId', 'resultName', 'hitSetKey'],
  previousStateParams
);

export const keyifyParamsForFiltersRequest = createSelector([paramsForFiltersRequest], (paramsForFiltersRequest) => {
  return keyify(paramsForFiltersRequest);
});

export const keyifyPreviousParamsForFiltersRequest = createSelector(
  [previousParamsForFiltersRequest],
  (previousParamsForFiltersRequest) => {
    return keyify(previousParamsForFiltersRequest);
  }
);

export const paramsForFilterGroups = stateParamsSelectorFactory([
  'context',
  'resultName',
  'databaseId',
  'order',
  'pageNumber',
  'query',
  'searchId',
  'sort',
  'hitSetKey',
]);

export const commercialSuppliersFilter = createSelector([filters], (filters) => {
  return filters.find((filter) => {
    return filter.get('value') === commercialSuppliersFilterId;
  });
});
